import {useEffect, useRef, useState} from "react";
import {
  BUZZVIL_AOS_APP_ID,
  BUZZVIL_AOS_UNIT_ID,
  BUZZVIL_IOS_APP_ID,
  BUZZVIL_IOS_UNIT_ID,
} from "utils";
import styles from "./index.module.scss";

const Interstital = ({buzzvilTest, setBuzzvilTest}) => {
  const adRef = useRef(null);
  const ctaRef = useRef(null);

  const [isInit, setIsInit] = useState(false);
  const [nativeAdInfo, setNativeAdInfo] = useState(true);

  useEffect(() => {
    setBuzzvilTest(buzzvilTest + "interstital");
    checkInit();
  }, [isInit]);

  const checkInit = () => {
    if (window.BuzzAdBenefit) {
      if (isInit) {
        setBuzzvilTest(buzzvilTest + "interstital isInit true");
        checkBenefitLogin();
      } else {
        setBuzzvilTest(
          buzzvilTest + "interstital isInit false, buzzAdBenefit reset",
        );
        window.BuzzAdBenefit.init({
          appId: getAppId(),
        });
        setIsInit(true);
      }
    } else {
      setBuzzvilTest(buzzvilTest + "interstital window.BuzzAdBenefit false");
    }
  };

  const getAppId = () => {
    const ANDROID_APP_ID = BUZZVIL_AOS_APP_ID;
    const IOS_APP_ID = BUZZVIL_IOS_APP_ID;

    setBuzzvilTest(
      buzzvilTest +
        `interstital window.BuzzAdBenefit.platform ${window.BuzzAdBenefit.platform}`,
    );
    switch (window.BuzzAdBenefit.platform) {
      case "android":
        return ANDROID_APP_ID;
      case "ios":
        return IOS_APP_ID;
      default:
        setBuzzvilTest(buzzvilTest + "not supported platform");
    }
  };

  const checkBenefitLogin = () => {
    setBuzzvilTest(buzzvilTest + "interstital checkBenefitLogin");

    window.BuzzAdBenefit.ensureAuthenticated
      .then(() => {
        return window.BuzzAdBenefit.loadAd({
          unitId: {
            android: BUZZVIL_AOS_UNIT_ID,
            ios: BUZZVIL_IOS_UNIT_ID,
          },
        });
      })
      .then(nativeAd => {
        setBuzzvilTest(buzzvilTest + "interstital An ad is loaded!");
        populateAd(nativeAd);
        setNativeAdInfo(nativeAd);
      })
      .catch(e => {
        if (e.message === "EMPTY_RESPONSE") {
          setBuzzvilTest(
            buzzvilTest + "interstital checkBenefitLogin error NO FILL",
          );
        } else {
          setBuzzvilTest(
            buzzvilTest +
              `interstital checkBenefitLogin error An error is detected while loading ad: ${e.message}`,
          );
        }
        setBuzzvilTest(buzzvilTest + e);
        hideAd();
      });
  };

  const populateAd = nativeAd => {
    const adListener = {
      onImpressed: function (adRef, nativeAd) {
        console.log("ON IMPRESSED: The ad is impressed.");
      },
      onClicked: function (adRef, nativeAd) {
        console.log("ON CLICKED: The ad is clicked.");
      },
      onRewardRequested: function (adRef, nativeAd) {
        console.log("ON REWARD REQUESTED: Reward is requested.");
      },
      onRewarded: function (adRef, nativeAd, result) {
        console.log("ON REWARDED: The result of Reward: " + result);
      },
      onParticipated: function (adRef, nativeAd) {
        console.log("ON PARTICIPATED: The ad is set to particiated.");
        updateCtaView(ctaRef, nativeAd); // 아래에서 설명
      },
      onVideoError: function (
        placementView,
        nativeAd,
        errorCode,
        errorMessage,
      ) {
        console.error(
          "ON VIDEO ERROR: An error is detected: " +
            errorCode +
            "\n" +
            errorMessage,
        );
      },
    };

    window.BuzzAdBenefit.registerNativeAd(
      nativeAdInfo,
      adRef.current,
      adListener,
    );
    renderAd(adRef.current, nativeAd);
  };

  const renderAd = (placementView, nativeAd) => {
    setBuzzvilTest(buzzvilTest + "interstital renderAd!");

    placementView.style.display = "";
    placementView
      .getElementsByClassName("icon")[0]
      .setAttribute("src", nativeAd.iconUrl);
    placementView.getElementsByClassName("title")[0].innerHTML = nativeAd.title;
    placementView.getElementsByClassName("description")[0].innerHTML =
      nativeAd.description;

    updateCtaView(placementView.getElementsByClassName("cta")[0], nativeAd);
  };

  const updateCtaView = (ctaView, nativeAd) => {
    var ctaTextHeader = "";
    if (nativeAd.reward) {
      if (nativeAd.participated) {
        // CtaView의 디자인을 '이미 참여하여 리워드 지급 불가능 상태'로 표시
      } else {
        // CtaView의 디자인을 '참여 시 리워드 지급 가능 상태'로 표시
        ctaTextHeader = "+" + nativeAd.reward + " ";
      }
    } else {
      // CtaView의 디자인을 '지급 가능한 리워드 없음' 상태로 표시
    }
    ctaView.innerText = ctaTextHeader + nativeAd.callToAction;
  };

  const hideAd = () => {
    setBuzzvilTest(buzzvilTest + "interstitial hideAd");
    adRef.current.style.display = "none";
  };

  return (
    <div ref={adRef} className={`post native-ad ${styles.interstital}`}>
      <div className="buzz-mediaview clickable" />
      <div className="info">
        <div className="icon-wrapper clickable">
          <img className="icon" alt="" />
        </div>
        <h5 className="title clickable">clickable</h5>
      </div>
      <div className="description">test description</div>
      <div className="button-wrapper">
        <button ref={ctaRef} className="cta clickable" />
      </div>
    </div>
  );
};

export default Interstital;
